// src/components/resources/tools/generators/BuyerPersona/Icons.tsx

import RiDiscountPercentLine from '~/icons/remix/generated/RiDiscountPercentLine'
import RiWallet3Line from '~/icons/remix/generated/RiWallet3Line'
import RiVipLine from '~/icons/remix/generated/RiVipLine'
import RiDiamondRingLine from '~/icons/remix/generated/RiDiamondRingLine'
import RiShoppingBasketLine from '~/icons/remix/generated/RiShoppingBasketLine'
import RiPriceTagLine from '~/icons/remix/generated/RiPriceTagLine'
import RiUserSearchLine from '~/icons/remix/generated/RiUserSearchLine'
import RiUserCommunityLine from '~/icons/remix/generated/RiUserCommunityLine'
import RiTeamLine from '~/icons/remix/generated/RiTeamLine'
import RiFocus2Line from '~/icons/remix/generated/RiFocus2Line'
import RiBarChartBoxLine from '~/icons/remix/generated/RiBarChartBoxLine'
import RiFlaskLine from '~/icons/remix/generated/RiFlaskLine'
import RiTestTubeLine from '~/icons/remix/generated/RiTestTubeLine'
import RiSeoLine from '~/icons/remix/generated/RiSeoLine'
import RiServiceLine from '~/icons/remix/generated/RiServiceLine'
import RiVerifiedBadgeLine from '~/icons/remix/generated/RiVerifiedBadgeLine'
import RiSparklingLine from '~/icons/remix/generated/RiSparklingLine'
import RiFlashlightLine from '~/icons/remix/generated/RiFlashlightLine'
import RiMoneyDollarCircleLine from '~/icons/remix/generated/RiMoneyDollarCircleLine'
import RiAdvertisementLine from '~/icons/remix/generated/RiAdvertisementLine'
import RiAwardLine from '~/icons/remix/generated/RiAwardLine'
import RiLineChartLine from '~/icons/remix/generated/RiLineChartLine'
import RiMegaphoneLine from '~/icons/remix/generated/RiMegaphoneLine'
import RiSignpostLine from '~/icons/remix/generated/RiSignpostLine'
import RiUserSmileLine from '~/icons/remix/generated/RiUserSmileLine'
import RiEmotionUnhappyLine from '~/icons/remix/generated/RiEmotionUnhappyLine'
import RiErrorWarningLine from '~/icons/remix/generated/RiErrorWarningLine'
import RiFirstAidKitLine from '~/icons/remix/generated/RiFirstAidKitLine'
import RiCapsuleLine from '~/icons/remix/generated/RiCapsuleLine'
import RiMedicineBottleLine from '~/icons/remix/generated/RiMedicineBottleLine'
import RiFeedbackLine from '~/icons/remix/generated/RiFeedbackLine'
import RiChatQuoteLine from '~/icons/remix/generated/RiChatQuoteLine'
import RiAlarmWarningLine from '~/icons/remix/generated/RiAlarmWarningLine'
import RiRouteLine from '~/icons/remix/generated/RiRouteLine'
import RiMap2Line from '~/icons/remix/generated/RiMap2Line'
import RiStarLine from '~/icons/remix/generated/RiStarLine'
import RiShoppingCart2Line from '~/icons/remix/generated/RiShoppingCart2Line'
import RiTimeLine from '~/icons/remix/generated/RiTimeLine'
import RiCheckLine from '~/icons/remix/generated/RiCheckLine'
import RiCheckboxCircleLine from '~/icons/remix/generated/RiCheckboxCircleLine'
import RiListCheck3 from '~/icons/remix/generated/RiListCheck3'
import RiSurveyLine from '~/icons/remix/generated/RiSurveyLine'
import RiUserLine from '~/icons/remix/generated/RiUserLine'
import RiHeartLine from '~/icons/remix/generated/RiHeartLine'
import RiGraduationCapLine from '~/icons/remix/generated/RiGraduationCapLine'
import { cn } from '~/lib/utils'

type Size = 'xs' | 'sm' | 'md' | 'lg'
const H: Record<Size, string> = { xs: 'h-3', sm: 'h-4', md: 'h-5', lg: 'h-6' }
const W: Record<Size, string> = { xs: 'w-3', sm: 'w-4', md: 'w-5', lg: 'w-6' }

type Tint =
  | 'muted'        // text-gray-500…
  | 'primary'      // indigo
  | 'success'      // green
  | 'warning'      // amber
  | 'danger'       // red
  | 'emphasis'     // slate-900 / slate-50
  | 'purple'       // purple (for backward compatibility)
  | 'blue'         // blue
  | 'teal'         // teal
  | 'violet'      // violet

const TINT: Record<Tint, string> = {
  muted:    'text-gray-500 dark:text-gray-400',
  primary:  'text-indigo-600 dark:text-indigo-400',
  success:  'text-green-600 dark:text-green-400',
  warning:  'text-amber-700 dark:text-amber-200',
  danger:   'text-red-600 dark:text-red-400',
  emphasis: 'text-slate-900 dark:text-slate-50',
  purple:   'text-purple-500 dark:text-purple-400',
  blue:     'text-blue-500 dark:text-blue-400',
  teal:     'text-teal-500 dark:text-teal-400',
  violet:   'text-violet-500 dark:text-violet-400',
}

type Margin = 'none' | 'xs' | 'sm' | 'md'
const M: Record<Margin, string> = { none: '', xs: 'mr-1', sm: 'mr-2', md: 'mr-3' }

type IconProps = {
  size?: Size
  tint?: Tint
  margin?: Margin
  className?: string
}

export const SalePromoIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiDiscountPercentLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const WalletIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiWallet3Line className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const StarIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiStarLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const VIPIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiVipLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const DiamondRingIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiDiamondRingLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const ShoppingBasketIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiShoppingBasketLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const ShoppingCartIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiShoppingCart2Line className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const CheckmarkIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiCheckLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const CheckmarkCircleIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiCheckboxCircleLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const ChecklistAbstractIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiListCheck3 className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const ClipboardIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiSurveyLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const ClockIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiTimeLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const PriceTagIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiPriceTagLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const UserTargetingIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiUserSearchLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const LookalikeTargetingIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiUserCommunityLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const UserGroupIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiTeamLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const UserIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiUserLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const TargetingIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiFocus2Line className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const KPIsIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiBarChartBoxLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const TestingFlaskIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiFlaskLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const TestingTubeIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiTestTubeLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const SearchIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiSeoLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const HeartIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiHeartLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const GraduationCapIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiGraduationCapLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const HandshakeHeartIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiServiceLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const SuccessIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiVerifiedBadgeLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const OptimizationSparkleIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiSparklingLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const OptimizationFlashlightIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiFlashlightLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const BudgetCircleIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiMoneyDollarCircleLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const AdvertisementIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiAdvertisementLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const AwardBadgeIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiAwardLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const LineChartIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiLineChartLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const MegaphoneIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiMegaphoneLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const FeedbackChatBubbleIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiFeedbackLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const ChatBubbleQuoteIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiChatQuoteLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const MedicineBottleIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiMedicineBottleLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const PillCapsuleIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiCapsuleLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const FirstAidKitIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiFirstAidKitLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const RouteArrowIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiRouteLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const MapIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiMap2Line className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const SignpostIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiSignpostLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const SmileyFaceIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiUserSmileLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const EmotionUnhappyIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiEmotionUnhappyLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const AlarmIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiAlarmWarningLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const ErrorWarningIcon = ({ size = 'sm', tint = 'purple', margin = 'none', className }: IconProps): JSX.Element => (
  <RiErrorWarningLine className={cn(H[size], W[size], TINT[tint], M[margin], className)} />
)

export const BrandLoyaltyCheckmarkIcon = ({ size = 'sm', tint = 'purple', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
  </svg>
)

export const BrandLoyaltyHeartIcon = ({ size = 'sm', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
  </svg>
)

export const BudgetIcon = ({ size = 'sm', tint = 'success', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
)

export const HighPriceSensitivityIcon = ({ size = 'md', tint = 'muted', margin = 'none', className }: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
)

export const KPIIcon = ({ size = 'sm', tint = 'primary', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
)

export const BudgetAllocationIcon = ({ size = 'sm', tint = 'success', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
)

export const TestVariablesIcon = ({ size = 'sm', tint = 'blue', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
  </svg>
)

export const SuccessMetricsIcon = ({ size = 'sm', tint = 'warning', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
  </svg>
)

export const OptimizationStrategiesIcon = ({ size = 'sm', tint = 'primary', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
)

// Social Media Platform Icons
export const FacebookIcon = ({ size = 'xs', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
)

export const InstagramIcon = ({ size = 'xs', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.148-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
  </svg>
)

export const TwitterIcon = ({ size = 'xs', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="currentColor" viewBox="0 0 24 24">
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
  </svg>
)

export const LinkedInIcon = ({ size = 'xs', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
)

export const TikTokIcon = ({ size = 'xs', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
)

export const PinterestIcon = ({ size = 'xs', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.218-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/>
  </svg>
)

export const YouTubeIcon = ({ size = 'xs', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="currentColor" viewBox="0 0 24 24">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
)

export const GoogleIcon = ({ size = 'xs', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="currentColor" viewBox="0 0 24 24">
    <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"/>
  </svg>
)

export const GoogleColorIcon = ({ size = 'xs', tint: _tint = 'muted', margin = 'none', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], M[margin], className)} viewBox="0 0 24 24" fill="currentColor">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
)

export const PhoneIcon = ({ size = 'sm', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
)

export const EmailIcon = ({ size = 'sm', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
)

export const DesktopIcon = ({ size = 'sm', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
)

export const MobileIcon = ({ size = 'sm', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
  </svg>
)

export const InPersonIcon = ({ size = 'sm', tint = 'muted', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
)

export const ChallengesIcon = ({ size = 'sm', tint = 'danger', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
)

export const GoalsIcon = ({ size = 'sm', tint = 'blue', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
  </svg>
)

export const PreferencesIcon = ({ size = 'sm', tint = 'purple', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
  </svg>
)

export const CommunicationIcon = ({ size = 'sm', tint = 'teal', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
  </svg>
)

export const DemographicsIcon = ({ size = 'sm', tint = 'emphasis', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
)

export const JobRoleIcon = ({ size = 'sm', tint = 'emphasis', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
)

export const DecisionAuthorityIcon = ({ size = 'sm', tint = 'warning', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
)

export const AnalyticsIcon = ({ size = 'sm', tint = 'blue', margin = 'xs', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
)

export const TimelineIcon = ({ size = 'sm', tint = 'warning', margin = 'none', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
)

export const ResourcesIcon = ({ size = 'sm', tint = 'success', margin = 'none', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
  </svg>
)

export const CompetitorsIcon = ({ size = 'sm', tint = 'danger', margin = 'none', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
)

export const InnovationIcon = ({ size = 'sm', tint = 'violet', margin = 'none', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
  </svg>
)

export const StackedDollarBillsIcon = ({ size = 'sm', tint = 'success', margin = 'none', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
)

export const GiftIcon = ({ size = 'sm', tint = 'muted', margin = 'none', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
  </svg>
)

export const ScalesOfJusticeIcon = ({ size = 'sm', tint = 'muted', margin = 'none', className }: IconProps): JSX.Element => (
  <svg className={cn(H[size], W[size], TINT[tint], M[margin], className)} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
  </svg>
)
